export function formatPhoneNumber(prefix = null, num: string):string {
    if (!num) return '';
    const [int] = num.toString().split('.');
    if (!int) return '';
    const str = prefix ? prefix + ' ' : '';
    return str + int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}